<template>
  <v-container>

    <v-layout justify-center>
      <v-flex fluid>

        <v-card>

          <v-toolbar card class="secondary">
            <v-icon>group</v-icon>
            <v-spacer></v-spacer>
            <v-btn fab small flat class="mx-0" @click="populateTable">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn fab small flat depressed class="mx-0">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>

          <v-alert :value="load_error" type="error" outline class="ma-3">{{ load_error }}</v-alert>

          <v-data-table :headers="headers" :items="items" :loading="loading" :rows-per-page-items="[10,20,50]">
            <template slot="items" slot-scope="props">
              <tr v-bind:class="{ 'grey--text': !props.item.active }">
                <td>{{ props.item.account_id }}</td>
                <td>{{ props.item.name }}</td>
                <!-- <td class="text-xs-center hidden-sm-and-down">
                  <v-icon>{{ props.item.active ? "radio_button_checked" : "radio_button_unchecked" }}</v-icon>
                </td> -->
                <td class="text-xs-center">
                  <v-btn icon class="mx-0">
                    <v-icon class="my-1" color="green">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0">
                    <v-icon class="my-1" color="red">delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>

        </v-card>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
export default {
  name: 'accounts',
  data: () => ({
    headers: [
      { text: 'Account ID', value: 'account_id', width: '1%'  },
      { text: 'Description', value: 'name' },
      // { 'text': 'Active', 'value': 'active', 'sortable': false, 'align': 'center', 'class': "hidden-sm-and-down" },
      { text: 'Actions', sortable: false, 'align': 'center', width: '15%' }
    ],
    items: [],
    loading: false,
    load_error: ''
  }),
  methods: {
    populateTable: function () {
      this.loading = true
      this.items = []
      this.$api.get('/accountlist').then(response => {
        this.items = response.data.data.slice()
        this.loading = false
      }).catch(e => {
        this.loading = false
        if (!e.response) {
          this.load_error = 'No response from API server.'
        } else {
          this.load_error = 'Error loading table data (error ' + e.response.status + ')'
        }
      })
    }
  },
  beforeMount: function() {
    this.populateTable()
  }
}
</script>

<style scoped>
</style>
